module.exports = __webpack_public_path__ + "static/fonts/NotoSansKR-Light.1f7c8be.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/nca/css/font/NotoSansKR-Light.woff
// module id = UrsZ
// module chunks = 0